var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"ModalViewPDF","title":"PDF","size":"xl"},scopedSlots:_vm._u([{key:"default",fn:function({  }){return [_c('iframe',{staticStyle:{"height":"70vh","width":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }